import { Tooltip } from '@prenuvo/halo';

import { PreferenceRadioButton } from './preference-radio-button.component';
import { PreferenceRadioOption } from './preferences.model';

interface PreferenceRadioProps {
  disabled: boolean;
  isFirst: boolean;
  isLast: boolean;
  isSelected: boolean;
  onChange: (value: string) => void;
  option: PreferenceRadioOption;
}

export function PreferenceRadio({
  disabled,
  isFirst,
  isLast,
  isSelected,
  onChange,
  option,
}: PreferenceRadioProps) {
  const hasTooltip = option.tooltip && typeof option.tooltip === 'string';

  const button = (
    <PreferenceRadioButton
      disabled={disabled}
      isFirst={isFirst}
      isLast={isLast}
      isSelected={isSelected}
      onChange={onChange}
      option={option}
    />
  );

  if (hasTooltip) {
    return (
      <Tooltip content={option.tooltip} side="bottom">
        <span className="flex">{button}</span>
      </Tooltip>
    );
  }

  return <span className="flex">{button}</span>;
}
